export default "__VITE_ASSET__BoSWNdPC__"